export const mileages =  [
    {
        value: 'km',
        label: {
            ru: 'км',
            en: 'km',
            es: 'km'
        },
        fullLabel: {
            ru: 'в километрах (км)',
            en: 'in kilometers (km)',
            es: 'en kilómetros (km)'
        },
    },
    {
        value: 'mi',
        label: {
            ru: 'ми.',
            en: 'mi',
            es: 'mi'
        },
        fullLabel: {
            ru: 'в милях (ми.)',
            en: 'in miles (mi)',
            es: 'en millas (mi)'
        },
    },
]